function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "results-of-chaos-experiments_svg__b"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#23C386",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2A8F9D",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "69.927%",
  x2: "50%",
  y2: "100%",
  id: "results-of-chaos-experiments_svg__c"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#49DFBD",
  stopOpacity: 0,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#23BB88",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "results-of-chaos-experiments_svg__e"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#23C386",
  stopOpacity: 0,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2A8F9D",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "results-of-chaos-experiments_svg__h"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7A3390",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#512D93",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "69.927%",
  x2: "50%",
  y2: "100%",
  id: "results-of-chaos-experiments_svg__j"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#793390",
  stopOpacity: 0,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7A3390",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "results-of-chaos-experiments_svg__l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7A3390",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#512D93",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "results-of-chaos-experiments_svg__m"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7A3390",
  stopOpacity: 0,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#512D93",
  offset: "100%"
})), /*#__PURE__*/React.createElement("filter", {
  x: "-14.7%",
  y: "-7.2%",
  width: "129.4%",
  height: "114.5%",
  filterUnits: "objectBoundingBox",
  id: "results-of-chaos-experiments_svg__d"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4,
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  x: "-21.2%",
  y: "-20%",
  width: "142.4%",
  height: "140%",
  filterUnits: "objectBoundingBox",
  id: "results-of-chaos-experiments_svg__f"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6,
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  x: "-17.6%",
  y: "-15.2%",
  width: "135.3%",
  height: "130.3%",
  filterUnits: "objectBoundingBox",
  id: "results-of-chaos-experiments_svg__i"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5,
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  x: "-14.7%",
  y: "-9.8%",
  width: "129.4%",
  height: "119.7%",
  filterUnits: "objectBoundingBox",
  id: "results-of-chaos-experiments_svg__k"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4,
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  x: "-21.2%",
  y: "-11%",
  width: "142.4%",
  height: "122.1%",
  filterUnits: "objectBoundingBox",
  id: "results-of-chaos-experiments_svg__n"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6,
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("path", {
  d: "M104.276 71.865a1.507 1.507 0 00-1.318-1.247c-10.887-1.23-16.971-5.124-20.998-7.702-1.991-1.274-3.562-2.28-5.14-2.653a9.612 9.612 0 00-4.263.004c.122-7.588-3.75-14.754-11.537-21.333l-1.581-1.335c-7.787-6.58-15.5-9.201-22.96-7.814a9.62 9.62 0 00-.71-4.205c-.631-1.492-1.886-2.874-3.474-4.624-3.214-3.541-8.072-8.888-11.1-19.411a1.496 1.496 0 00-.44-.718V.825h-.001L20.713.79l-.006-.006a1.508 1.508 0 00-2.431.79c-.17.599-1.014 3.104-1.242 3.778-.928 2.743-1.618 9.177-4.82 15.1l3.509 2.907-4.62-1.182c-.01.012 2.212 2.52 2.212 2.52l-3.2-.785a20.481 20.481 0 00-2.42 5.864l6.047 3.105-.63.002C9.6 30.577 5.48 30.588 2.179 34.23c-6.157 6.792 5.64 24.59 5.64 24.59s-2.215 2.128-6.397 1.429c-.568-.094-1.04.52-.752 1.02 1.767 3.095 6.924 4.758 6.924 4.758s-1.642 2.724-4.711 4.299c-.496.254-.52.984-.031 1.249 3.19 1.728 8.25.448 8.25.448s-1.548 2.545-3.638 4.527c-.378.359-.248 1.02.25 1.177 2.227.705 6.215.605 9.702-.792.84 1.45 2.593 3.33 5.215 5.596a.063.063 0 01.012.01l.187.157.016.015c4.659 3.819 7.554 5.185 9.059 4.265a4.128 4.128 0 011.967-.391c-7.56 2.855-11.215 15.875-11.215 15.875s3.242-11.93-2.028-17.763c-4.358-4.821-13.354-2.854-17.007-.931a.966.966 0 00.074 1.748c3.524 1.495 4.627 2.98 4.627 2.98s-5.076.254-7.767 3.107c-.505.535-.147 1.43.579 1.558 3.875.674 5.844 2.47 5.844 2.47s-3.633 2.598-4.815 6.402c-.245.789.56 1.542 1.309 1.192 4.11-1.92 9.325-1.353 9.325-1.353s-11.846 23.473-3.4 27.993c1.25.669 3.233.51 5.638-.26l-.307 1.38S.607 141.015.938 148.865c.302 7.133 5.069 10.915 7.578 13.843.38.444 1.088.368 1.386-.134 1.726-2.9.59-5.575.59-5.575s3.21 1.88 5.467 3.759c.44.367 1.128.185 1.339-.35.956-2.417-.126-4.814-.126-4.814s2.442.875 4.592 1.655c.926.337 1.843-.561 1.506-1.488-1.371-3.776-5.72-7.148-5.72-7.148s28.824-9.08 22.758-25c-1.12-2.937-2.641-5.55-4.33-7.873 8.485-8.102 14.632-17.765 10.797-23.996.844.158 1.657.26 2.425.279 1.757.04 4.395-.184 7-2.596 1.009-.928 2-2.352 3.013-4.321.042.047.087.08.129.127 2.97 3.125 5.034 4.149 7.212 4.792l1.53-4.75 2.23 5.266a18.368 18.368 0 009.066-2.772l-.954-4.243 3.77 2.332a32.833 32.833 0 001.876-1.604c5.557-5.237 12.973-7.304 15.826-8.868.656-.356 3.002-1.647 3.546-1.91.605-.291.945-.948.832-1.611",
  id: "results-of-chaos-experiments_svg__a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.757 37.275a1.433 1.433 0 00-.829.067c-9.688 3.804-16.528 3.237-21.054 2.862-2.237-.185-4.004-.331-5.493.056a9.094 9.094 0 00-3.578 1.898C80.534 35.732 74.1 31.435 64.636 29.37l-1.92-.42c-9.463-2.063-17.103-.838-22.75 3.642a9.141 9.141 0 00-2.45-3.205l-.015-.011c-1.193-.972-2.86-1.574-4.973-2.338-4.272-1.544-10.726-3.878-17.944-11.367a1.419 1.419 0 00-.74-.42l-.009-.002a1.43 1.43 0 00-1.696 1.097 1.44 1.44 0 00.006.647c.125.577.53 3.056.636 3.723.44 2.716 2.72 8.424 2.664 14.82l4.237.882-4.405 1.06c-.003.015 2.977 1.135 2.977 1.135l-3.036.76a19.494 19.494 0 00.574 6l6.457-.08-5.6 2.987c.91 2.468 2.572 4.638 4.773 6.225l2.246-1.561-.232 2.513 3.684-3.077-1.475 4.064c.223.058.452.106.69.147.855.188 1.72.334 2.59.405a31.06 31.06 0 00-1.38 4.028 1.452 1.452 0 00-.028.13c-.185 1.097-.292 2.576.24 4.256-1.437-.978-2.403 27.932 1.178 24.938 1.983 4.244-5.032 7.295-2.879 8.035 2.151.74 9.272-.938 10.958-5.064 1.837 4.253-2.112 7.144.07 7.699 3.304.842 12.658-9.176 9.996-17.193a14.897 14.897 0 00-1.209-2.656c1.385.654 3.356 1.279 5.902 1.865l.016.003.226.05c.006 0 .013.003.02.003.791.16 1.517.289 2.206.399-.54 5.366 1.261 10.895 3.3 11.54 2.144.68.317-3.86 4.125-6.5-.748 4.393 4.412 9.579 6.63 10.087 2.22.508-2.126-5.787 1.8-8.344 1.458 4.433 6.098 5.855 6.913 4.78.568-.75-3.496-4.58-.089-7.415 4.203 1.588 23.023 6.702 28.25-2.167 4.863-8.256-2.765-15.538-13.245-16l-.768-4.328 4.214 3.43a17.44 17.44 0 006.378-6.354l-2.684-3.14 4.202.283c.335-.758.627-1.52.862-2.18 2.34-6.866 7.646-11.897 9.347-14.478.394-.59 1.791-2.717 2.13-3.18a1.434 1.434 0 00-.849-2.25z",
  id: "results-of-chaos-experiments_svg__g"
}));

var _ref2 = /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  xlinkHref: "#results-of-chaos-experiments_svg__a",
  transform: "translate(205 13)"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  fill: "url(#results-of-chaos-experiments_svg__b)",
  x: 10,
  width: 85,
  height: 179,
  rx: 1
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  fill: "url(#results-of-chaos-experiments_svg__e)",
  opacity: 0.312,
  filter: "url(#results-of-chaos-experiments_svg__f)",
  transform: "matrix(1 0 0 -1 0 484)",
  x: 10,
  y: 197,
  width: 85,
  height: 90,
  rx: 1
});

var _ref5 = /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  transform: "rotate(-20 63.995 58.143)",
  xlinkHref: "#results-of-chaos-experiments_svg__g"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  fill: "url(#results-of-chaos-experiments_svg__l)",
  transform: "matrix(-1 0 0 1 163 0)",
  x: 39,
  y: 70,
  width: 85,
  height: 100,
  rx: 1
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  fill: "url(#results-of-chaos-experiments_svg__m)",
  opacity: 0.312,
  filter: "url(#results-of-chaos-experiments_svg__n)",
  transform: "rotate(180 81.5 269.5)",
  x: 39,
  y: 188,
  width: 85,
  height: 163,
  rx: 1
});

function SvgResultsOfChaosExperiments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 370,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _ref2, /*#__PURE__*/React.createElement("g", {
    transform: "translate(153)"
  }, _ref3, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#results-of-chaos-experiments_svg__c)",
    style: {
      mixBlendMode: "screen"
    },
    filter: "url(#results-of-chaos-experiments_svg__d)",
    transform: "matrix(1 0 0 -1 0 565)",
    y: 196,
    width: 85,
    height: 173,
    rx: 1
  }), _ref4, /*#__PURE__*/React.createElement("rect", {
    stroke: "#23BB88",
    style: {
      mixBlendMode: "screen"
    },
    y: 12,
    width: 85,
    height: 157,
    rx: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 13)"
  }, _ref5, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#results-of-chaos-experiments_svg__h)",
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#results-of-chaos-experiments_svg__i)",
    transform: "matrix(-1 0 0 1 163 0)",
    x: 39,
    y: 70,
    width: 85,
    height: 99,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#results-of-chaos-experiments_svg__j)",
    style: {
      mixBlendMode: "screen"
    },
    filter: "url(#results-of-chaos-experiments_svg__k)",
    transform: "matrix(1 0 0 -1 0 575)",
    x: 29,
    y: 224,
    width: 85,
    height: 127,
    rx: 1
  }), _ref6, _ref7, /*#__PURE__*/React.createElement("rect", {
    stroke: "#793390",
    style: {
      mixBlendMode: "screen"
    },
    x: 29,
    y: 48,
    width: 85,
    height: 85,
    rx: 1
  }))));
}

export default "data:image/svg+xml;base64,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";
export { SvgResultsOfChaosExperiments as ReactComponent };